import { TemplatePage } from '@/components/layout/TemplatePage'
import html from './template/PortfolioDetails.html?raw'

export function PortfolioDetails() {
  return <TemplatePage html={html} />
}
